export default "__VITE_ASSET__BRebYn7R__"